import axios from 'axios'
import { Message } from 'element-ui'
import {Notification} from 'element-ui'
import md5 from 'js-md5'
import router from '../router';

axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

// let baseUrl =  'http://eval.test.imspp.org.cn:50001/imspp_sys'; //配置的后台地址
// let baseUrl =  'http://192.168.2.248:50010/imspp_sys'; //配置的后台地址
// let baseUrl = window.global_config.BASE_URL; //配置的后台地址
let baseUrl = window.global_config.BASE_URL; //配置的后台地址

// let baseUrl =  'http://192.168.2.198:50010/imspp_sys'; //配置的后台地址




export default{ baseUrl };

let TokenInvalidFlag=false;//记录token是否失效


//axios请求拦截器 添加token
axios.interceptors.request.use(
  config => {
    if (sessionStorage.token) { //添加token信息在请求中
      config.headers.Authorization = "Bearer " + sessionStorage.token
    }

    const date = new Date().getTime();
    var hzArr = baseUrl.split("/"); //统一配置的后台接口 例：http://192.168.2.248:50000/imspp_sys
    var hz = hzArr[hzArr.length-1];//统一配置的后台接口后缀 例：imspp_sys

    var path = '';
    var arr = config.url.split(baseUrl);
    var dd = arr[arr.length - 1];
    //get传参 ？后面的参数，这类是不需要加密，get 斜杠/传参需要加密
    if (dd.indexOf("?") != -1) {
      var ff = dd.split("?");
      path="/"+hz+ff[0]
    } else {
      path = "/"+hz+arr[arr.length-1]
    }
    config.headers.sign = md5("Byquick-GZH-2022%^$*&#" + date + path).toUpperCase()
    config.headers.invokeTime = date

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
)

//响应拦截器
axios.interceptors.response.use(

  response => {

    // console.log(response.status)
    if (response.status === 200) {
      if(response.data.code=="401") {
      //  Message.error(response.data.msg+",请重新登录")
      //  setTimeout(function(){ 
      //   router.push("/login")
      //  },1000)
       if(TokenInvalidFlag===false){
          // Message.error('登录失效，请重新登录！');
          // Notification.error('登录失效，请重新登录！')
          sessionStorage.removeItem("user"); 
          sessionStorage.removeItem("passwd"); 
          sessionStorage.removeItem("token");
          this.$notify.error({
            title: '提示',
            message: '登录失效，请重新登录！'
          });
          TokenInvalidFlag = true;
          setTimeout(function(){  router.push("/index") },1000)
        }
        
      }
      else{
        TokenInvalidFlag = false
      }
      return Promise.resolve(response)
    }else {
      TokenInvalidFlag = false
      return Promise.reject(response)
    }
  },

  // 服务器状态码不是2开头的的情况, 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  error => {
    console.log(error)
    if (error.response.status) {
      switch (error.response.status) {
        case 500:
         
          Notification.error('服务繁忙，请稍等再试！')
          break
        case 401:
          if(TokenInvalidFlag===false){

            
            Message.error('登录失效，请重新登录！')
            TokenInvalidFlag = true;
            setTimeout(function(){  router.push("/index") },1000)
          sessionStorage.removeItem("user"); 
          sessionStorage.removeItem("passwd"); 
          sessionStorage.removeItem("token"); 
          }
          break
        default:
          console.log('失败了1')
          // router.push('/abnormal')
          // Notification.error('操作失败！')
          break;
      }
      return Promise.reject(error.response)
    }else{
      console.log('失败了2')
      // Notification.error('操作失败！')
      // router.push('/abnormal')
    }
  }
 
  // response => {
  //   console.log(response.status)
  //   if (response.status === 200) {
  //     if(response.data.code=="401") {
  //     //  Message.error(response.data.msg+",请重新登录")
  //     //
  //     //   router.push("/login")
  //     //  
  //         Message.error('登录失效，请重新登录！');
  //         TokenInvalidFlag = true;
  //        router.push("/Signin") 

      
        
  //     }
     
  //   }else {
  //     TokenInvalidFlag = false
  //     return Promise.reject(response)
  //   }
  // },

  // // 服务器状态码不是2开头的的情况, 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // error => {
  //   console.log(response.status)
  //   console.log(error)
  //   if (error.response.status) {
  //     switch (error.response.status) {
  //       case 500:
  //         Message.error("服务繁忙，请稍等再试！")
  //         break
  //       case 401:
  //         if(TokenInvalidFlag===false){
  //           Message.error('登录失效，请重新登录！');
  //           TokenInvalidFlag = true;
  //          router.push("/index") 
  //         }
  //         break
  //       default:
  //         Message.error("操作失败！")
  //         break;
  //     }
  //     return Promise.reject(error.response)
  //   }else{
  //     Message.error("操作失败！")
  //   }
  // }
)


/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + url, params).then(res => { //baocunshiyixia
      resolve(res.data)
    }).catch(err => {
     

      
          
  //  router.push("/index") 

      reject(err.data)
    })
  })
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve,reject)=>{
      axios.get(baseUrl+url,params).then(res=>{
          resolve(res.data)
      }).catch(err => {
        
          
      //  router.push("/index") 
          reject(err.data)
      })
  })
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
  return new Promise((resolve,reject)=>{
      axios.delete(baseUrl+url,params).then(res=>{
          resolve(res.data)
      }).catch(err => {
        
          
      //  router.push("/index") 
          reject(err.data)
      })
  })
}
// export function delt(url, param) {
//   return new Promise((resolve,reject)=>{
//       axios.delete(baseUrl+url,{params: param}).then(res=>{
//           resolve(res.data)
//       }).catch(err => {
//           reject(err.data)
//       })
//   })
// }
export function delt(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params).then(res => {
      resolve(res.data)
    }).catch(err => {
      
          
    //  router.push("/index") 
      reject(err)
    })
  })
}

export function put(url,params){
  return new Promise((resolve,reject)=>{
      axios.put(baseUrl+url,params).then(res=>{
          resolve(res.data)
      }).catch(err => {
        
          
      //  router.push("/index") 
          reject(err.data)
      })
  })
}

export function blob(url,params){
  return new Promise((resolve,reject)=>{
      axios.defaults.responseType = "blob";
      axios.post(baseUrl+url,params).then(res=>{
          resolve(res)
      }).catch(err => {
        
          
      //  router.push("/index") 
          reject(err.data)
      })
  })
}
export function blobs(url,params){
  return new Promise((resolve,reject)=>{
      axios.defaults.responseType = "blob";
      axios.get(baseUrl+url,params).then(res=>{
          resolve(res)
      }).catch(err => {
        
          
      //  router.push("/index") 
          reject(err.data)
      })
  })
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function getUrl(url, params = '') {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl + url, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      
          
    //  router.push("/index") 
      reject(err.data)

    })
  })
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getFormdata(url, params = '') {
  return new Promise((resolve, reject) => {
    axios.get(baseUrl + url, {
      params,
      headers: {
        'Content-Type':'multipart/form-data'
      }
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      
          
    //  router.push("/index") 
      reject(err.data)

    })
  })
}

/**
 * del方法，对应delete请求 
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function delUrl(url, params = '') {
  return new Promise((resolve, reject) => {
    axios.delete(baseUrl + url, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      
          
    //  router.push("/index") 
      reject(err.data)

    })
  })
}

